import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"
import { TIME_FORMATS } from "constants/index"
import moment from "moment"
import { Badge } from "reactstrap"

const userManagementListColumns = selectedEvent => {
  let defaultColumns = [
    {
      text: "Name",
      dataField: "first_name",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, row) => {
        return (
          <>
            {row.first_name} {row.last_name}{" "}
            {row.viewed_exp?.date ? (
              <em style={{ fontSize: "smaller" }}>
                (Viewed at{" "}
                {moment(row.viewed_exp?.date).format(
                  TIME_FORMATS(
                    moment().diff(moment(row.viewed_exp?.date), "days")
                  ).DATETIME
                )}
                )
              </em>
            ) : (
              <em style={{ fontSize: "smaller" }}>(Unviewed)</em>
            )}
          </>
        )
      },
    },
    {
      text: "Email",
      dataField: "email",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, user) => <>{user.email}</>,
    },
    {
      text: "User Tags",
      dataField: "user_tags",
      formatter: (cellContent, user) => {
        let tags = user?.user_tags ? user?.user_tags?.split(",") : null
        if (!tags) {
          return <></>
        } else
          return tags.map((tag, key) => (
            <Badge
              className={"font-size-10 badge-soft-primary ms-2"}
              color="primary"
              pill
              key={key}
            >
              {tag}{" "}
            </Badge>
          ))
      },
    },
    {
      text: "User Status",
      dataField: "user_status",
      formatter: (cellContent, user) => <>{user.user_status}</>,
    },
    {
      text: "Access Type",
      dataField: "rsvp_string_type",
      formatter: (cellContent, user) => <>{user.rsvp_string_type}</>,
    },
    {
      text: "Email Last Sent",
      dataField: "last_sent",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, user) => (
        <>
          {user?.sent_count > 0
            ? user?.last_sent + " (" + user.sent_count + ")"
            : user?.invite_id
            ? "Never sent"
            : ""}
        </>
      ),
    },
    {
      text: "Email Status",
      dataField: "status",
      sort: true,
      sortCaret: order => (
        <span className="sort-button">
          <SortIcon order={order} />
        </span>
      ),
      formatter: (cellContent, user) => <>{user.status}</>,
    },
  ]

  if (selectedEvent?.show_rsvp) {
    let rsvpColumns = [
      {
        text: "RSVP",
        dataField: "rsvp_status",
        formatter: (cellContent, user) => {
          switch (user?.rsvp_status) {
            case 0:
              return "No"
            case 1:
              return `Yes (${user?.total_participants} coming)`
            case 2:
              return `Maybe (${user?.total_participants} coming)`
            default:
              return "No Reply"
          }
        },
      },
      {
        text: "Replied",
        dataField: "rsvp_updated",
        formatter: (cellContent, user) => (
          <>
            {!!user?.rsvp_updated?.date && user.rsvp_status !== 3
              ? getFormattedTime(user?.rsvp_updated?.date)
              : ""}
          </>
        ),
      },
    ]

    defaultColumns.splice(3, 0, rsvpColumns[0], rsvpColumns[1])
  }

  return defaultColumns
}

export default userManagementListColumns
